import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import { defaultDateFormat } from 'Common/GeneralHelper';
import { Filter, Main } from 'Containers/';
import { LoadingPage, YesNoDialog } from 'Components/';
import { toastType, createToast } from 'Common/ToastHelper';
import { NotificationAndDirectCertifiedLettersForm } from './components/NotificationAndDirectCertifiedLettersForm';
import { NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME } from 'Common/FormEnum';
import { NotificationAndDirectCertifiedLettersFieldEnum as Fields } from 'Common/FieldEnum';
import * as useStudentAddressSelectors from 'Common/Components/UseStudentAddressButtonGroup/Selectors';
import {
  checkForBadEmails,
  clearBadEmails,
  getNotificationAndDirectCertifiedLetters,
  clearReport,
  clearErrors,
} from './state/letter/actions';
import { getControlInfo } from 'State/controlInfo/actions'; //prob needed to set default provision type
import {
  LetterTypeEnum,
  LetterStringTypesEnum,
} from './helpers/LetterTypeEnum';
import { isPreferenceDisabled } from 'Common/Security/SecurityHelpers';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import _ from 'lodash';

export class NotificationAndDirectCertifiedLettersContainer extends Component {
  state = {
    formValues: null,
    showEmailConfirmation: false,
  };

  startProcessing = formValues => {
    this.props.getNotificationAndDirectCertifiedLetters(formValues);
  };

  handleSubmit = formValues => {
    if (formValues[Fields.IsEmail] === false) {
      this.startProcessing(formValues);
    } else {
      //store the form values so can submit after email confirmation
      this.setState({ formValues, showEmailConfirmation: true });
    }
  };

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME,
        saveButtonProps: {
          content: 'Process',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.checkForBadEmails();
    this.props.getControlInfo();
  }

  componentDidUpdate(prevProps, prevState) {
    const { error } = this.props;

    if (error) {
      createToast(toastType.error, 'Error', error.toString(), true);
    }
  }

  getBadEmailCount = letterType => {
    var badCount = this.props.badNotificationEmailsHistIds.length;
    if (letterType === LetterTypeEnum.DirectCertification) {
      badCount = this.props.badDCEmailsHistIds.length;
    }
    return badCount;
  };

  getDistinctBadEmailCount = letterStringTypesEnum => {
    const { badEmails } = this.props;
    return _.filter(badEmails, { LetterType: letterStringTypesEnum }).length;
  };

  getBadEmailQuestion = letterType => {
    var badCount = this.getDistinctBadEmailCount(
      LetterStringTypesEnum.Notification
    );
    var letterDesc = 'Notification';
    if (letterType === LetterTypeEnum.DirectCertification) {
      badCount = this.getDistinctBadEmailCount(
        LetterStringTypesEnum.DirectCertification
      );
      letterDesc = 'Direct Certification';
    }

    const plural = badCount > 1 ? 's' : '';
    const wasWere = badCount > 1 ? 'were' : 'was';
    const badEmailAddressDesc =
      badCount > 1 ? 'bad email addresses' : 'a bad email address';
    const thisThese = badCount > 1 ? 'these' : 'this';
    var title = `[${badCount}] ${letterDesc} email${plural} ${wasWere} returned due to ${badEmailAddressDesc}.`;
    var title2 = `Do you want to print ${thisThese} letter${plural}?`;
    return (
      <span>
        {title}
        <br />
        {title2}
      </span>
    );
  };

  declineToPrintFailedEmails = letterType => {
    const data = {
      letterType: letterType,
      letterHistoryIds:
        letterType === LetterTypeEnum.DirectCertification
          ? this.props.badDCEmailsHistIds
          : this.props.badNotificationEmailsHistIds,
    };
    this.props.clearBadEmails(data);
  };

  acceptToPrintFailedEmails = letterType => {
    const data = {
      LetterType: letterType,
      IsPrintBadEmails: true,
      BadEmailLetterHistoryIds:
        letterType === LetterTypeEnum.DirectCertification
          ? this.props.badDCEmailsHistIds
          : this.props.badNotificationEmailsHistIds,
    };
    this.startProcessing(data);
  };

  render() {
    const disableEmail = isPreferenceDisabled(
      PrefEnum.AllowEmailNotificationDC,
      this.props.security.preferences
    );

    return (
      <Fragment>
        {this.props.loading ? <LoadingPage /> : undefined}
        <Filter title={'Notification And Direct Certified Letters'} />
        <Main {...this.getMainProps()}>
          <NotificationAndDirectCertifiedLettersForm
            onSubmit={this.handleSubmit}
            disableEmail={disableEmail}
            initialValues={{
              [Fields.FromDate]: defaultDateFormat(moment()),
              [Fields.ToDate]: defaultDateFormat(moment()),
              [Fields.AllDates]: true,
              [Fields.DateOfLetter]: defaultDateFormat(moment()),
              [Fields.ProvisionType]: this.props.provisionType,
              [Fields.SortBy]: 0,
              [Fields.Selectby]: 0,
              [Fields.IsPrinted]: 0,
              [Fields.LetterType]: 0,
              [Fields.Status]: 0,
              [Fields.ShowAdverseChangeOnly]: false,
              [Fields.ShowSiteName]: false,
              [Fields.IsEmail]: false,
              [Fields.AllDates]: true,
              [Fields.UseStudentAddress]: this.props.useStudentAddress,
            }}
          />
        </Main>

        <YesNoDialog
          showDialog={this.state.showEmailConfirmation}
          title={'Confirm sending via email.'}
          question={
            <span>
              Emails will immediately be sent to parents/guardians; there is no
              preview before they send.
              <br />
              Do you wish to continue?
            </span>
          }
          yesCallback={() => {
            this.setState({ showEmailConfirmation: false });
            this.startProcessing(this.state.formValues);
          }}
          noCallback={() => this.setState({ showEmailConfirmation: false })}
        />

        {this.getBadEmailCount(LetterTypeEnum.Notification) > 0 &&
        !disableEmail ? (
          <YesNoDialog
            showDialog={this.getBadEmailCount(LetterTypeEnum.Notification) > 0}
            title={'Notification has failed email(s).'}
            question={this.getBadEmailQuestion(LetterTypeEnum.Notification)}
            yesCallback={() => {
              return this.acceptToPrintFailedEmails(
                LetterTypeEnum.Notification
              );
            }}
            noCallback={() => {
              return this.declineToPrintFailedEmails(
                LetterTypeEnum.Notification
              );
            }}
          />
        ) : this.getBadEmailCount(LetterTypeEnum.DirectCertification) > 0 &&
          !disableEmail ? (
          <YesNoDialog
            showDialog={
              this.getBadEmailCount(LetterTypeEnum.DirectCertification) > 0
            }
            title={'Direct Certification has failed email(s).'}
            question={this.getBadEmailQuestion(
              LetterTypeEnum.DirectCertification
            )}
            yesCallback={() => {
              return this.acceptToPrintFailedEmails(
                LetterTypeEnum.DirectCertification
              );
            }}
            noCallback={() => {
              return this.declineToPrintFailedEmails(
                LetterTypeEnum.DirectCertification
              );
            }}
          />
        ) : (
          undefined
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    notificationLetters,
  } = state.NotificationAndDirectCertifiedLettersState;
  return {
    loading: notificationLetters.loading,
    provisionType: state.CommonState.controlInfo.data.ProvisionTypeDefault,
    badEmails: notificationLetters.badEmails,
    badNotificationEmailsHistIds:
      notificationLetters.badNotificationEmailsHistIds,
    badDCEmailsHistIds: notificationLetters.badDCEmailsHistIds,
    security: state.SecurityState,
    useStudentAddress: useStudentAddressSelectors.getUseStudentAddressSetting(
      state,
      NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME,
      false
    ),
  };
};

export const NotificationAndDirectCertifiedLetters = withRouter(
  connect(mapStateToProps, {
    checkForBadEmails,
    clearBadEmails,
    getControlInfo,
    getNotificationAndDirectCertifiedLetters,
    clearReport,
    clearErrors,
  })(NotificationAndDirectCertifiedLettersContainer)
);



// WEBPACK FOOTER //
// ./src/pages/notificationanddirectcertifiedletters/NotificationAndDirectCertifiedLetters.js